const COMMUNITIES_GROUPS_ROUTE_PREFIX = '/communities/groups/'
const COMMUNITIES_USERS_ROUTE_PREFIX = '/communities/users/'

export function isCommunitiesGroupsRoutePath(path?: string): boolean {
  if (!path) return false
  return path.startsWith(COMMUNITIES_GROUPS_ROUTE_PREFIX)
}

export function isCommunitiesUsersRoutePath(path?: string): boolean {
  if (!path) return false
  return path.startsWith(COMMUNITIES_USERS_ROUTE_PREFIX)
}

export function isCrossingCommunitiesGroupsUsersLayout(fromPath?: string, toPath?: string): boolean {
  const fromGroups = isCommunitiesGroupsRoutePath(fromPath)
  const fromUsers = isCommunitiesUsersRoutePath(fromPath)
  const toGroups = isCommunitiesGroupsRoutePath(toPath)
  const toUsers = isCommunitiesUsersRoutePath(toPath)

  return (fromGroups && toUsers) || (fromUsers && toGroups)
}
